// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"63f2905b","239":"a4598000","455":"2e58a862"}[chunkId] + ".chunk.js";
};